module.exports = __webpack_public_path__ + "static/media/WhitespaceBadOptimized.2674c66a.jp2";